import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import AutoTranslate from "./i18n/AutoTranslate";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { NavbarProvider } from "@/contexts/NavbarContext";

const AUTH_PATHS = ['/giris', '/uye-ol'];

function Layout() {
  const location = useLocation();
  const isAuth = AUTH_PATHS.includes(location.pathname);

  return (
    <>
      <Navbar />
      <AppRoutes />
      {!isAuth && <Footer />}

      {/* Floating buttons — auth sayfalarında gizle */}
      {!isAuth && (
        <>
          {/* WhatsApp floating button */}
          <a
            href="https://wa.me/905058916367"
            target="_blank"
            rel="nofollow noreferrer"
            className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center rounded-full cursor-pointer"
            style={{
              background: '#25D366',
              boxShadow: '0 4px 24px rgba(37,211,102,0.45)',
              transition: 'all 0.3s cubic-bezier(0.16,1,0.3,1)',
            }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLElement).style.transform = 'scale(1.12)';
              (e.currentTarget as HTMLElement).style.boxShadow = '0 8px 40px rgba(37,211,102,0.6)';
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLElement).style.transform = 'scale(1)';
              (e.currentTarget as HTMLElement).style.boxShadow = '0 4px 24px rgba(37,211,102,0.45)';
            }}
          >
            <i className="ri-whatsapp-line text-white text-2xl"></i>
            <span
              className="absolute inset-0 rounded-full"
              style={{ background: 'rgba(37,211,102,0.35)', animation: 'ping-slow 2s ease-out infinite' }}
            ></span>
          </a>
        </>
      )}
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <NavbarProvider>
        <I18nextProvider i18n={i18n}>
          <AutoTranslate />
          <BrowserRouter basename={__BASE_PATH__}>
            <Layout />
          </BrowserRouter>
        </I18nextProvider>
      </NavbarProvider>
    </ThemeProvider>
  );
}

export default App;
